module.exports = __webpack_public_path__ + "static/media/Enclave-bylaws.b91e4995.pdf";